"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INPUT_DATASET_KEY = exports.EXPOSE_DATASET_KEY = exports.POP_CLICK_DATASET_KEY = exports.CLICK_DATASET_KEY = void 0;
exports.CLICK_DATASET_KEY = "alEtClick";
exports.POP_CLICK_DATASET_KEY = "alEtPopClick";
exports.EXPOSE_DATASET_KEY = "alEtExpose";
exports.INPUT_DATASET_KEY = "alEtInput";
